import { Box } from "@mui/material";
import { useState, useEffect, useCallback } from "react";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import punchListAtom, { fetchQCPunchlistStatusCountsAtom } from "../../../../atoms/quality/QualityAtoms";
import CircularProgress from '@mui/material/CircularProgress';
import dashboardAtoms, { fetchBlocks, fetchMapRender, } from "../../../../atoms/Dashboard/DashboardAtom";
import RightPanel from "./rightPanel";
import LayoutComponent from "../../../dashboard/Layout";
import settingsAtom from "../../../../atoms/settings/SettingsAtom";
import PunchlistHeader from "../header";


const Mapview = () => {
  const projectId = localStorage.getItem("project_id");
  const navigate = useNavigate();
  const [data] = useAtom(dashboardAtoms);
  const [list] = useAtom(punchListAtom);
  const [settings] = useAtom(settingsAtom);
  const [, setMap] = useAtom(fetchMapRender)
  const [, setBlocks] = useAtom(fetchBlocks);
  const [selectPart, setSelectPart] = useState([])
  const [loader, setLoader] = useState(false)
  const [countsLoader, setCountsLoader] = useState(false)
  const [view, setView] = useState("map view");
  const [active, setActive] = useState("external");
  const [scope, setScope] = useState("All");
  const [selectBlock, setSelectBlock] = useState(false);
  const [isSelect, setIsSelect] = useState(true);
  const [, setQCPunchlistStatusWiseCounts] = useAtom(fetchQCPunchlistStatusCountsAtom)


  const fetchAllData = useCallback(async () => {
    setLoader(true)
    try {
      await Promise.allSettled([
        setBlocks(''),
        setMap(''),
        getQCPunchlistCounts()
      ]);
    } catch (error) {
      console.error("Error in fetchAllData:", error);
    } finally {
      setLoader(false)
    }
    // eslint-disable-next-line
  }, [setBlocks, setMap]);

  useEffect(() => {
    if (projectId) {
      fetchAllData();
    }
  }, [projectId, fetchAllData]);

  useEffect(() => {
    if (view === "list view") {
      navigate("/quality/qc-punchlist")
    }
    // eslint-disable-next-line
  }, [view])
  useEffect(() => {
    getQCPunchlistCounts()
    // eslint-disable-next-line
  }, [scope, active, selectPart])

  const getQCPunchlistCounts = async () => {
    setCountsLoader(true)
    try {
      setQCPunchlistStatusWiseCounts({ visibility: active === "external" ? 1 : 0, scope: scope, blockId: selectPart[0] })
    } catch (err) {
      console.error(err)
    } finally {
      setCountsLoader(false)
    }
  }

  const handleScopeChange = (event) => {
    setScope(event.target.value);
  };
  return (
    <Box>
      <Box px={4} py={2} mt={1.5}>
        <PunchlistHeader
          active={active}
          setActive={setActive}
          view={view}
          setView={setView}
        />
      </Box>
      <Box sx={{ borderTop: '1px solid #e0e0e0' }}></Box>
      <Box px={4} >

        <Box sx={{ display: 'flex', width: '100%', position: "relative" }}>


          <Box sx={{ height: 'calc(100vh - 200px)', width: "70%", borderRight: '1px solid #e0e0e0' }}>
            {loader ?
              <Box sx={{
                height: "calc(100vh - 200px)",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}>
                <CircularProgress />
              </Box>
              :
              <LayoutComponent
                svgMap={data?.svgMap}
                loader={loader}
                blocks={data?.blocks}
                list={data?.list}
                projectList={settings?.projectList}
                selectBlock={selectBlock}
                setSelectBlock={setSelectBlock}
                selectPart={selectPart}
                setSelectPart={setSelectPart}
                isSelect={isSelect}
                setIsSelect={setIsSelect}
                type="QC"
              />
            }
          </Box>

          <Box sx={{ height: 'calc(100vh - 200px)', width: '30%' }}>
            <RightPanel
              data={list}
              loading={countsLoader}
              blockName={selectPart.length !== 0 ? data?.blocks?.find(block => block.id === parseInt(selectPart[0]))?.name || `Block ${selectPart[0]}` : null}
              scope={scope}
              handleScopeChange={handleScopeChange}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Mapview;